/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SummarizeToolCallRequestBody = {
  /**
   * The ID of the chat containing the tool call
   */
  id: string;
  /**
   * The ID of the assistant message containing the tool call
   */
  messageId: string;
  /**
   * The provider-assigned ID of the tool call
   */
  toolCallId: string;
};

/** @internal */
export type SummarizeToolCallRequestBody$Outbound = {
  id: string;
  message_id: string;
  tool_call_id: string;
};

/** @internal */
export const SummarizeToolCallRequestBody$outboundSchema: z.ZodMiniType<
  SummarizeToolCallRequestBody$Outbound,
  SummarizeToolCallRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    messageId: z.string(),
    toolCallId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      messageId: "message_id",
      toolCallId: "tool_call_id",
    });
  }),
);

export function summarizeToolCallRequestBodyToJSON(
  summarizeToolCallRequestBody: SummarizeToolCallRequestBody,
): string {
  return JSON.stringify(
    SummarizeToolCallRequestBody$outboundSchema.parse(
      summarizeToolCallRequestBody,
    ),
  );
}
